export class PopupToggleService {
  constructor() {
    this.state = {};
  }

  isOpen(id) {
    return !!this.state[id];
  }

  toggle(id, value = !this.state[id]) {
    this.state[id] = value;
  }
}
